import TimeAgo from 'react-timeago-i18n';
import { UsersIcon, EyeSlashIcon } from '@phosphor-icons/react';

const ActivityCard = ({ item, onClick }) => {
  const text = ["Just now", "Right now"];

  return (
    <div className="card activity-item" onClick={onClick}>
      <div className="flex row space center medium-gap">
        <div className="flex col small-gap">
          <div className="flex row medium-gap center">
            <p className="medium">{item.name}</p>
            <span className={`badge ${item.type === 'Assets' ? 'asset' : 'liability'}`}>
              {item.type === 'Assets' ? 'Asset' : 'Liability'}
            </span>
            {item.ownership < 100 && <div className='icon medium'><UsersIcon /></div>}
            {!item.include_networth && <div className='icon medium'><EyeSlashIcon /></div>}
          </div>
          <div className="flex row medium-gap center">
            <p className="regular o60">{item.classification}</p>
            {item.description && <p className="regular o60">• {item.description}</p>}
          </div>
        </div>

        <div className="flex col end">
          <p className="number medium">£{Math.abs(item.valuation).toLocaleString()}</p>
          <p className="updated small o60">
            <TimeAgo date={item.updated} hideSecondsText={text} />
          </p>
        </div>
      </div>
    </div>
  );
};

export default ActivityCard;
